// Mirrors the API's max (Joi.number().integer().max(1000000)).
export const MAX_PRICE_CENTS = 1000000

// Parses flexible price input ("$3,000.00", "19.99", "3000") into integer cents.
// Empty input -> { cents: null }. Returns { cents, error } where error is a
// user-facing message on invalid input.
export function parsePriceToCents(raw) {
  if (raw === null || raw === undefined || String(raw).trim() === '') {
    return { cents: null, error: null }
  }

  const cleaned = String(raw).replace(/[$,\s]/g, '')

  if (!/^\d+(\.\d{1,2})?$/.test(cleaned)) {
    return { cents: null, error: 'Enter a valid price (e.g. 3,000.00)' }
  }

  // Math.round avoids float drift (19.99 * 100 === 1998.9999…).
  const cents = Math.round(parseFloat(cleaned) * 100)

  if (cents < 0 || cents > MAX_PRICE_CENTS) {
    return { cents: null, error: 'Price must be between $0 and $10,000' }
  }

  return { cents, error: null }
}

// Formats integer cents into a dollar string ("3,000.00"); '' for empty input.
export function formatCentsToInput(cents) {
  if (cents === null || cents === undefined || Number.isNaN(cents)) return ''
  return (cents / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
